import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaskPopupRoutingModule } from './task-popup-routing.module';
import { TaskPopupComponent } from './task-popup.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { DocEditorModule } from 'src/app/shared/doc-editor/doc-editor.module';
import { CreateCampaignTemplateModule } from '../../whatsappChatModule/create-campaign-template/create-campaign-template.module';


@NgModule({
  declarations: [
    TaskPopupComponent
  ],
  imports: [
    CommonModule,
    TaskPopupRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonFileUploadModule,
    CommonImagesModule,
    DocEditorModule,
    CreateCampaignTemplateModule
  ],
  exports:[
    TaskPopupComponent
  ]
})
export class TaskPopupModule { }
